import React from 'react';
import { connect } from 'react-redux';
import ModalContainer from 'components/shared/modal/modal_container';
import RenderInBody from 'components/shared/render_in_body';
import { routes } from 'constants/config';
import { hasFeature } from 'selectors/index';
import { Button, ButtonGroup, Icon } from 'ui';
import { setQueryString } from 'utils/url';
import request from 'utils/request_ajax';
import SelectWorkspace from './SelectWorkspace';

const preventLineBreaks = e => {
  if (e.key === 'Enter') e.preventDefault();
};

class LessonCreationModal extends React.Component {
  state = {
    title: this.props.title || '',
    description: this.props.description || '',
    workspaceId: '',
    loading: false,
  };

  createLesson() {
    const { title, description, workspaceId } = this.state;
    const lessonUrl = setQueryString(routes.NEW_LESSON, {
      title,
      description,
      workspace_id: workspaceId,
    });

    window.location.assign(lessonUrl);
  }

  async createLessonFromTemplate() {
    const { title, description, workspaceId } = this.state;
    const { templateId } = this.props;
    const templateUrl = routes.USE_TEMPLATE(templateId);

    const data = await request.post(templateUrl, {
      title,
      description,
      workspace_id: workspaceId,
    });

    window.location.assign(routes.LESSON_OVERVIEW.EDIT_LESSON(data.id));
  }

  handleInputChange = e => {
    const { name } = e.target;
    let { value } = e.target;
    if (name === 'description') {
      value = value.replace(/\r?\n|\r/g, ' ');
    }
    this.setState({ [name]: value });
  };

  handleSubmit = e => {
    e.preventDefault();
    this.setState(
      { loading: true },
      this.props.isTemplate ? this.createLessonFromTemplate : this.createLesson,
    );
  };

  render() {
    const { title, description, loading } = this.state;
    const { workspaces, features, closeModal } = this.props;

    const canAssignWorkspace = features.workspaces && workspaces.length > 1;
    return (
      <RenderInBody>
        <ModalContainer
          className="ModalTakeover-background Modal-background d-f ai-c"
          onEscape={closeModal}
        >
          <div className="ModalTakeover-container LessonCreationModal">
            <div className="LessonCreationModal-body">
              <form onSubmit={this.handleSubmit}>
                <div className="LessonCreationModal-title">
                  {t('lessons.create_modal.new_lesson')}
                </div>
                <div className="LessonCreationModal-subtitle">
                  {t('lessons.create_modal.description')}
                </div>
                <label
                  htmlFor="title"
                  className="LessonCreationModal-inputTitle"
                >
                  {t('common.title')}
                </label>
                <input
                  id="title"
                  name="title"
                  className="NewInput NewInput--white NewInput--fw ModalTakeover-nameInput"
                  placeholder={t('common.enter_title')}
                  type="text"
                  onChange={this.handleInputChange}
                  value={title}
                  maxLength="255"
                />
                <label
                  htmlFor="description"
                  className="LessonCreationModal-inputTitle"
                >
                  {t('common.description')}
                </label>
                <textarea
                  id="description"
                  name="description"
                  className="NewInput NewInput--white NewInput--fw"
                  placeholder={t('common.enter_description')}
                  rows="3"
                  onChange={this.handleInputChange}
                  onKeyDown={preventLineBreaks}
                  value={description}
                />
                {canAssignWorkspace && (
                  <div>
                    <SelectWorkspace
                      workspaces={workspaces}
                      onChange={this.handleInputChange}
                    />
                  </div>
                )}
                <ButtonGroup alignEnd className="mt-32">
                  <Button customColor type="submit" loading={loading}>
                    {t('lessons.create_modal.create_lesson')}
                  </Button>
                </ButtonGroup>
              </form>

              <button
                type="button"
                className="u-resetBtn ModalTakeover-closeButton"
                aria-label={t('common.close')}
                onClick={closeModal}
              >
                <Icon name="error" />
              </button>
            </div>
          </div>
        </ModalContainer>
      </RenderInBody>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const features = ownProps.features
    ? { workspaces: ownProps.features.workspaces }
    : { workspaces: hasFeature(state, 'workspaces') };
  const workspaces = ownProps.workspaces || state.data.meta.workspaceOptions;

  return { features, workspaces };
};

export default connect(mapStateToProps)(LessonCreationModal);
